import React, { useState, useEffect } from 'react'
import ReactPaginate from 'react-paginate'
import Select from 'react-select'
import useDidMountEffect from './useDidMountEffect'
import { useLocation } from 'react-router-dom';
//import { useSelector } from 'react-redux'


function Pagination({ pagination = {}, paginate, showSelect, showInput, defaultSize = 20 }) {
	//const settings = useSelector(state => state.settings)
	const location = useLocation();

	const sizes = [
		{
			id: 5,
			name: '5'
		},
		{
			id: 10,
			name: '10'
		},
		{
			id: 20,
			name: '20'
		},
		{
			id: 50,
			name: '50'
		},
		{
			id: 100,
			name: '100'
		},
	]

	const [pageCount, setPageCount] = useState(0)
	const [inputPage, setInputPage] = useState(0)
	const [currentPage, setCurrentPage] = useState(0)
	const [size, setSize] = useState(defaultSize)

	async function getCurrentPage(pageNumber, bool = true) {
		console.log(currentPage);
		console.log(pageNumber.selected);

		if (bool && pageNumber.selected >= 0) {

			setCurrentPage(pageNumber.selected)
			paginate({ page: pageNumber.selected, page_size: size })
		}
	}

	function handlePageClick() {
		const newPage = parseInt(inputPage)

		if (newPage >= 1) {
			setCurrentPage(newPage - 1)
			getCurrentPage({ 'selected': newPage - 1 })
		}
	}

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		params.forEach((value, key) => {
			if (value) {
				if (key === 'size') {
					setSize(Number(value))
				}
				if (key === 'page') {
					setCurrentPage(Number(value))
				}
			}
		});
	}, [location.search]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (pagination?.response) {
			setPageCount(Math.ceil(pagination?.response?.total / size))
		}
		if (pagination?.total) {
			setPageCount(Math.ceil(pagination?.total / size))
		}
	}, [pagination, size]) // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		getCurrentPage({ selected: 0 })
	}, [size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="d-flex align-items-center">
				{showSelect &&
					<div className="pagination p-0">
						<Select
							options={sizes}
							value={sizes.find(option => option.id === size) || ''}
							onChange={(option) => setSize(option.id)}
							placeholder=""
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.id}
							menuPlacement="top"
							styles={{
								control: (provided, state) => ({
									...provided,
									background: '#fff',
									borderColor: '#f0f0f0',
									minHeight: '30px',
									height: '30px',
									boxShadow: state.isFocused ? null : null,
								}),
								valueContainer: (provided, state) => ({
									...provided,
									height: '30px',
									padding: '0 6px'
								}),
								input: (provided, state) => ({
									...provided,
									margin: '0px',
								}),
								indicatorSeparator: state => ({
									display: 'none',
								}),
								indicatorsContainer: (provided, state) => ({
									...provided,
									height: '30px',
								}),
							}}
						/>
					</div>
				}

				{(showInput && pageCount > 1) &&
					<div className="pagination position-relative">
						<input type="number" className="pagination-input"
							onChange={(e) => setInputPage(e.target.value)}
							onKeyUp={(event) => {
								if (event.key === 'Enter') {
									handlePageClick()
								}
							}}
						/>
						<div className="pagination-input-icon" onClick={() => handlePageClick()}>
							<i className="uil uil-angle-right"></i>
						</div>
					</div>
				}

				{pageCount > 1 &&

					<ReactPaginate
						forcePage={currentPage}
						breakLabel={'...'}
						breakClassName={'break-me'}
						pageCount={pageCount}
						marginPagesDisplayed={3}
						pageRangeDisplayed={3}
						onPageChange={getCurrentPage}
						containerClassName={'pagination'}
						activeClassName={'active'}
						pageClassName={'page-item'}
					/>

				}
			</div>
		</>
	)
}

export default Pagination